import {useCallback} from 'react';
import {useDispatch} from 'react-redux';

import {useCachedTable} from 'src/hooks/common-data-service/cached-table';
import {runAccountSearch} from 'src/openapi/admin/apis/RunAccountSearchApi';
import {useAppDispatch} from 'src/store/hooks';

import {userConferencesStateSelector} from '../slices/user-conferences-state.slice';
import {
    userConferencesActions,
    userConferencesDataSelector,
    userConferencesResultSelector,
} from '../slices/user-conferences.slice';

import type {UserConferencesCacheKeys} from '../typedef';
import type {AccountSearchCriteria} from 'src/openapi/admin/models/AccountSearchCriteria';
import type {AccountSearchResponse} from 'src/openapi/admin/models/AccountSearchResponse';


export const useGetUserConferences = () => {
    const apiDispatch = useAppDispatch();
    const dispatch = useDispatch();

    const getAction = useCallback((cacheKeys: UserConferencesCacheKeys) => apiDispatch(runAccountSearch(
        {
            accountSearchRequest: {
                searchCriteria: {accountIds: cacheKeys.searchCriteria.accountIds} as AccountSearchCriteria,
                sortCriteria: {
                    columnId: cacheKeys.sortCriteria.field,
                    direction: cacheKeys.sortCriteria.direction,
                },
                pagination: cacheKeys.pagination,
            },
        },
    )), [apiDispatch]);

    const setLoadedData = useCallback((
        response: AccountSearchResponse,
        cacheKeys: UserConferencesCacheKeys,
    ) => {
        dispatch(userConferencesActions.onSuccess(({
            cacheKeys,
            totalCount: response.totalCount,
            data: response.result,
        })));
    }, [dispatch]);

    return useCachedTable({
        dataSelector: userConferencesDataSelector,
        resultSelector: userConferencesResultSelector,
        stateSelector: userConferencesStateSelector,
        actions: userConferencesActions,
        getAction,
        onSuccessLoad: setLoadedData,
    });
};
